module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_card":"No cards added yet","text_remove_card":"Are you sure you want to remove this card?"},"id":{"no_card":"Belum ada kartu yang ditambahkan","text_remove_card":"Anda yakin ingin menghapus kartu ini?"}}')
  delete Component.options._Ctor
}
